import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './registrationPage.css';
import selsmartLogo from '../../assets/images/selsmart.png';
import GoogleLogo from '../../assets/images/Google_icon.png';
import FbLogo from '../../assets/images/fb_icon.png';
import { useUser } from '../../contexts/userContext';

const Register = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { setUserId, setUsername, setAuthToken, utm_session_id, setUtmSessionId, fetchCsrfToken } = useUser();
    const nameInputRef = useRef<HTMLInputElement>(null);
    const [showError, setShowError] = useState(false);
    const [mobileNo, setMobileNo] = useState('');
    const [loading, setLoading] = useState(false); // New loading state
    const query = new URLSearchParams(location.search);
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const version = process.env.REACT_APP_VERSION;
    const returnUrl = location.state?.returnUrl;
    const product = location.state?.product;
    const cartId = location.state?.cart_id;
    const session_code = location.state?.session_code;
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile_no: ''
    });

    const [errors, setErrors] = useState({
        name: '',
        email: '',
        mobile_no: ''
    });

    const [error, setError] = useState<string | null>(null);
    const utmSource = query.get('utm_source');
    let utmQuery = location.state?.utmQuery
    utmQuery = utmQuery || localStorage.getItem('utm_query_data')


    // Add utm_session_id to query

    if (utm_session_id) {
        query.set('utm_session_id', utm_session_id);
    }

    useEffect(() => {
        fetchSeoMetaDetails()
      },[]);
    
    const fetchSeoMetaDetails = async () => {
        try {
            const code = 'registration_page'
            const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
                {
                    method: 'GET',
                    headers: {
                        // Accept:'aplication/json',
                        "Content-Type": "application/json"

                    },
                    credentials: "include",
                    mode: "cors"

                }
            );
            if (!response.ok) throw new Error('Failed to fetch categories');
            const data = await response.json();
            await changeTitleAndMetaTags(data.result.page_title, { description: data.result.meta_description, keywords: data.result.meta_tag });
        } catch (error) {
            //console.error('Error fetching categories:', error);
        }
    };

    const changeTitleAndMetaTags = async (
        title: string,
        metaTags: { description?: string; keywords?: string;[key: string]: string | undefined }
    ) => {
        try {
            // Update the document title
            if (title) {
                document.title = title;
            } else {
                document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            }

            // Update or create meta tags
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    // Update existing meta tag
                    metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
                } else {
                    // Create new meta tag if it doesn't exist
                    const newMetaTag = document.createElement('meta');
                    newMetaTag.name = metaName;
                    newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                    document.head.appendChild(newMetaTag);
                }
            });

            // Cleanup function to reset the title and meta tags when unmounting
            return () => {
                document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
                Object.keys(metaTags).forEach((metaName) => {
                    const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                    if (metaTag) {
                        metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                    }
                });
            };
        } catch (error) {
            //console.error("Error updating title and meta tags:", error);
        }
    };

    const isValidForm = () => {
        const isNameValid = formData.name.trim().length >= 2;
        const isEmailValid = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(formData.email);
        const isMobileValid = formData.mobile_no.length === 10;
        return isNameValid && isEmailValid && isMobileValid;
    };
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        let updatedValue = value.trimStart();

        switch (name) {
            case 'name':
                updatedValue = updatedValue.replace(/[^a-zA-Z\s]/g, ''); // Only alphabets and spaces

                // Check if the value is empty or contains only spaces
                if (updatedValue.trim() === '') {
                    setErrors((prev) => ({ ...prev, name: 'Please enter the name' }));
                } else if (updatedValue.length > 50) {
                    setErrors((prev) => ({ ...prev, name: 'Name cannot exceed 50 characters' }));
                } else if (updatedValue.trim().length < 2) {
                    setErrors((prev) => ({ ...prev, name: 'Please enter at least 2 characters' }));
                } else {
                    setErrors((prev) => ({ ...prev, name: '' })); // Clear errors if valid
                }
                break;
            case 'email':
                updatedValue = updatedValue.replace(/\s/g, ''); // Remove spaces entirely

                if (updatedValue.trim() === '') {
                    setErrors((prev) => ({ ...prev, email: 'Please enter a valid email id' }));
                } else if (!/^[a-zA-Z0-9@._-]+$/.test(updatedValue)) {
                    setErrors((prev) => ({
                        ...prev,
                        email: 'Only alphabets, numbers, and special characters (@, ., -, _) are allowed',
                    }));
                } else if (!/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(updatedValue)) {
                    setErrors((prev) => ({ ...prev, email: 'Please enter a valid email id' }));
                } else if (/^[0-9]+@/.test(updatedValue)) {
                    // Check if the part before @ is only numeric
                    setErrors((prev) => ({ ...prev, email: 'The part before @ cannot be only numeric' }));
                }
                else if (updatedValue.length < 10) {
                    setErrors((prev) => ({ ...prev, email: 'Please enter a valid email id' }));
                } else {
                    setErrors((prev) => ({ ...prev, email: '' })); // Clear error
                }
                break;

            case 'mobile_no':
                updatedValue = updatedValue.replace(/[^0-9]/g, '').slice(0, 14); // Only numbers, max length 10
                if (!updatedValue) {
                    setErrors((prev) => ({ ...prev, mobile_no: 'Please enter a valid mobile number' }));
                } else if (updatedValue === '0000000000') {
                    setErrors((prev) => ({ ...prev, mobile_no: 'Invalid mobile number' }));
                }
                else if (updatedValue.length < 10) {
                    setErrors((prev) => ({ ...prev, mobile_no: '10-digit required' }));
                }
                else if (updatedValue.length > 10) {
                    setErrors((prev) => ({ ...prev, mobile_no: 'Please enter a valid 10-digit mobile number' }));
                }
                else if (updatedValue.startsWith('0')) {
                    setErrors((prev) => ({ ...prev, mobile_no: 'Please check the number you have entered. It starts with "0".' }));
                } else {
                    setErrors((prev) => ({ ...prev, mobile_no: '' }));
                }
                break;

            default:
                break;
        }

        setFormData({
            ...formData,
            [name]: updatedValue,
        });
    };

    const handleSignIn = () => {
        navigate('/login', {
            state: { returnUrl, product, cart_id: cartId, session_code },
        }
        )
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (errors.mobile_no !== '' || null) {
            return
        }

        if (!isValidForm()) {
            return; // Prevent submission if the form is invalid
        }

        setLoading(true);
        setError(null); // Clear any previous error

        try {
            const csrfToken = await fetchCsrfToken();
            const response = await fetch(`${backendUrl}api/v1/user/create?${utmQuery}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken,
                },
                credentials: "include",
                body: JSON.stringify(formData),

            });

            const data = await response.json();

            if (response.ok) {
                if (data.result && data.result.id) {

                    setUsername(data.result.name);
                    setAuthToken(data.result.remember_token);
                    sessionStorage.setItem('mobileNumber', JSON.stringify(formData.mobile_no));
                    navigate('/verify-otp', {
                        state: { user_id: data.result.id, returnUrl, product, user: data.result, cart_id: cartId, session_code, utmQuery },
                    });
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                } else {
                    // Handle any unexpected structure in the response
                    setError(data.result?.message || 'Unexpected error occurred');
                }
            } else {
                // Handle error from the backend (non-2xx HTTP status)
                setError(data.result?.message || 'Registration failed');
            }
        } catch (error: any) {
            // Handle network or other unexpected errors
            setError(error.message || 'Something went wrong. Please try again later');
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (nameInputRef.current) {
            nameInputRef.current.focus();
        }
    }, []);

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleSubmit(e); // Call handleSubmit when Enter is pressed
        }
    };
    const handleLogo = () => {
        navigate('/')
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const currentYear = new Date().getFullYear();

    return (
        <div>
            <nav className="navbar navbar-expand-lg bg-white- login_screen">
                <div className="container-fluid">
                    <a className="navbar-brand">
                        <img src={selsmartLogo} alt="logo" onClick={handleLogo} />
                    </a>
                    {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button> */}
                    <div className="collapse- navbar-collapse-" id="navbarSupportedContent-">
                        <ul className="navbar-nav mb-2- mb-lg-0 ms-auto">
                            <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="/">Home</a>
                            </li>
                        </ul>

                    </div>
                </div>
            </nav>

            <div className="container-fluid sign_in">
                <div className="row">
                    <div className="col-6 green_bg position-relative">
                        <div className="right-side">
                            <h1>Welcome to <br /><span className="selsmart-heading">Selsmart</span></h1>
                            <p className="welcome-text">Sell your used<br className="view" /> electronic appliances in <br className="view" />smart way with us!</p>
                            <hr className="white-line" />
                        </div>
                    </div>
                    <div className=" white_bg_right col-6">
                        <div className="left-side">
                            <div className="form-container">
                                <h2>Welcome Back <span>👋</span></h2>
                                <p>Today is a new day. It's your day. You shape it. Sign in to start managing your projects.</p>


                                {/* <form className="register-form" onSubmit={handleSubmit}  onKeyDown={handleKeyDown}> */}
                                <form className="register-form" onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
                                    <div className="input-group">
                                        <label className="register-label">Your Name<p className="required">*</p></label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            placeholder="Your name"
                                            ref={nameInputRef}
                                            maxLength={50} // Set maximum character limit to 50
                                            className={`register-input ${errors.name ? 'input-error' : ''}`}
                                        />
                                        {errors.name && <span className="error-message-reg">{errors.name}</span>}
                                    </div>

                                    <div className="input-group">
                                        <label className="register-label">Mobile No.<p className="required">*</p></label>
                                        <input
                                            type="tel"
                                            name="mobile_no"
                                            value={formData.mobile_no}
                                            onChange={handleChange}
                                            placeholder="+91-9999 999 999"
                                            maxLength={14}
                                            className={`register-input ${errors.mobile_no ? 'input-error' : ''}`}
                                        />
                                        {errors.mobile_no && <span className="error-message-reg">{errors.mobile_no}</span>}
                                    </div>
                                    <div className="input-group">
                                        <label className="register-label">E-Mail ID<p className="required">*</p></label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            maxLength={50}
                                            onKeyDown={(e) => {
                                                if (e.key === ' ') e.preventDefault(); // Prevent spaces
                                            }}
                                            placeholder="Example@email.com"
                                            className={`register-input ${errors.email ? 'input-error' : ''}`}
                                        />
                                        {errors.email && <span className="error-message-reg">{errors.email}</span>}
                                    </div>

                                    <button type="submit" className="register-button submit-btn" disabled={loading}>
                                        {loading ? 'Verifying...' : 'Next'}
                                    </button>
                                    {error && <p className="error-message-req-fail">{error}</p>}
                                </form>
                                <div className="register-link-login">

                                </div>
                                <div className="social-signin reg-">
                                    {/* <p>Or sign up with</p>
                                    <div className="social-buttons for_web">
                                        <button className="social-btn google-btn"> <img src={GoogleLogo} alt="google Logo" /> Sign up with Google</button>
                                        <button className="social-btn facebook-btn"><img src={FbLogo} alt="google Logo" /> Sign up with Facebook</button>
                                    </div>

                                    <div className="social-buttons for_mobile">
                                        <button className="social-btn google-btn"> <img src={GoogleLogo} alt="google Logo" />Google</button>
                                        <button className="social-btn facebook-btn"><img src={FbLogo} alt="google Logo" />Facebook</button>
                                    </div> */}
                                </div>
                                <p className="signin-link">Already have an account?<a onClick={handleSignIn}> Sign In</a></p>
                            </div>
                        </div>
                        <div className="copy_right">© 2024 All rights reserved.</div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Register;
